module.exports = __webpack_public_path__ + "img/delivery-tracking.5cced775.png";